<template>
  <div class="rows maitrises">
    <div class="rows">
      <div class="container">
        <div class="col-xs-3">
          <label for="dateCreation">
            Utilisateurs
          </label>
          <treeselect class="tree-select"  v-if="adminUsers.treeSelectAdminUsers"
                    ref="treeDates"
                    :multiple="true"
                    v-model="adminUsers.filters.idUsers"
                    :searchable="true"
                    :options="adminUsers.treeSelectAdminUsers"
                    sortValueBy="LEVEL"
                    :default-expand-level="1"
                    :limit="3"
                    :limitText="count => `et ${count} de plus`"
                    :max-height="300"
                    placeholder="Utilisateurs sélectionnés"
                    :allways-opened="false"
                    :disable-branch-nodes="true"
                    v-on:change="reloadUsers()"
                    @input="reloadUsers">
          </treeselect>
        </div>
      </div>
    </div>
    <div v-for="(value, label) in maitrisesStatus" v-bind:key="value">
      <h3>{{label}}</h3>
      <div class="row" v-for="maitrise in adminUsers.filteredAdminUsers" v-if="maitrise.actif == value && maitrise.deleted === false" v-bind:key="maitrise.id">
        <div class="col-xs-3">
          <span class="title-item">Nom, prénom</span>
          <span class="text-item">{{maitrise.nom}}, {{maitrise.prenom}}</span>
        </div>
        <div class="col-xs-2">
            <span class="title-item">Ville</span>
            <span class="text-item">
            {{ maitrise.ville_id | allVillesName }}
          </span>
        </div>
        <div class="col-xs-2">
            <span class="title-item">Profil</span>
            <span class="text-item">
            {{ maitrise.jwtAuthorities | profileName }}
          </span>
        </div>
        <div class="col-xs-2">
          <span class="title-item">Arrondissement de rattachement</span>
          <span class="text-item">
            {{  maitrise.arrondissement_id | allArrondissementName }}
          </span>
        </div>
        <div class="col-xs-3">
          <div class="actions">
            <a class="action-edit" v-on:click="$emit('edit', maitrise)" v-if="maitrise.actif">
              <img src="../../../../../static/img/edit-icon.svg">
            </a>
            <a class="action-delete right-separator" v-on:click="$emit('delete', maitrise)" v-if="maitrise.actif">
              <img src="../../../../../static/img/delete-icon.svg">
            </a>
            <a class="action-delete right-separator" v-on:click="$emit('reactivate', maitrise)" v-if="!maitrise.actif">
              Réactiver
            </a>
            <a class="action-delete right-separator" v-on:click="$emit('deleteDef', maitrise)" v-if="!maitrise.actif">
              <img src="../../../../../static/img/delete-icon-def.svg">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import Treeselect from '@riophae/vue-treeselect'

  export default {
    components: {Treeselect},
    computed: {
      ...mapState([
        'adminUsers',
        'villes',
      ]),
    },
    data: function () {
      return {
        maitrisesStatus: { 'Actifs': true, 'Inactifs': false },
      }
    },
    mounted: async function () {
      await this.$store.dispatch('fetchAllUsers');
      await this.$store.dispatch('fetchAllVilles');
      await this.$store.dispatch('fetchAllArrondissements');
    },
    methods: {
      reloadUsers: function () {
        if (this.adminUsers.filters.idUsers.length > 0) {
          console.log("filters => ", this.adminUsers.filters.idUsers);
          this.adminUsers.filteredAdminUsers = this.adminUsers.data.filter(maitrise =>
            this.adminUsers.filters.idUsers.some(m => maitrise.id === m)
          );
        } else {
          this.adminUsers.filteredAdminUsers = this.adminUsers.data;
        }
        this.$store.dispatch('updateAllUsersFilter');
      },
    },
  }
</script>
<style lang="scss">
  .rows.maitrises {
    margin-top: -35px;
  }
  h3 {
    text-transform: capitalize
  }
</style>



// WEBPACK FOOTER //
// UsersList.vue?78eadd0e